export default __webpack_public_path__ + "static/media/invitation_details.7071b06e.png";